/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useCurrentEditor, useEditorState } from "@tiptap/react";
import { ButtonTooltip } from "./button-tooltip";

/**
 * Renders a single toolbar button
 * @template {Commands} C
 * @param {ToolbarButtonProps<C>} props
 */
const ToolbarButtonColor = (props) => {
    
    // const command = props?.command;
    // const icon = props?.icon;
    // const activeIcon = props?.activeIcon ?? icon;
    const args = props?.args ?? [];
    const activeAttribute = props?.activeAttribute;
    const tooltip = props?.tooltip;
    const activeTooltip = props?.activeTooltip;
    const style = props?.style ?? {
        background: "#FFFFFF",
        borderRadius: "4px",
        border: "1px solid #DFDFDF",
        color: "#CECECE",
        fontFamily: "inherit",
        fontSize: ".875rem",
        fontWeight: 500,
        lineHeight: 1.0,
        height: "24px",
        width: "22px",
        margin: "none",
        padding: "1px 1px",
        position: "relative",
        bottom: "-6px",
        transition: "all .2s cubic-bezier(.65,.05,.36,1)",
    };
    
    const { editor } = useCurrentEditor();
    const editorIsActive = editor.isActive(activeAttribute, args[0]);
    const active = activeAttribute && editorIsActive;
    const disabled = !editor.can().chain().setColor().run();
    // const Icon = active ? activeIcon : icon;
    const title = active ? activeTooltip : tooltip;
    // const color = active ? "primary" : undefined;
    // Logger.debug({title, active, disabled, activeAttribute, command, tooltip})

    const editorState = useEditorState({
        editor,
        selector: (ctx) => {
            return {
                color: ctx.editor.getAttributes("textStyle").color,
                // isPurple: ctx.editor.isActive("textStyle", { color: '#958DF1' }),
                // isRed: ctx.editor.isActive("textStyle", { color: '#F98181' }),
                // isOrange: ctx.editor.isActive("textStyle", { color: '#FBBC88' }),
                // isYellow: ctx.editor.isActive("textStyle", { color: '#FAF594' }),
                // isBlue: ctx.editor.isActive("textStyle", { color: '#70CFF8' }),
                // isTeal: ctx.editor.isActive("textStyle", { color: '#94FADB' }),
                // isGreen: ctx.editor.isActive("textStyle", { color: '#B9F18D' }),
            };
        },
    });
    
    const executeCommand = (event) => {
        editor.chain().focus().setColor(event.currentTarget.value).run();
    };
    
    if (!editor) {
        return null;
    }
    
    return (
        <ButtonTooltip title={title}>
            <input
                type="color"
                onInput={executeCommand}
                value={editorState.color}
                data-testid="setColor"
                disabled={disabled}
                style={style}
            />
        </ButtonTooltip>
    );
};
export { ToolbarButtonColor };
